import {
  ChangeDetectionStrategy,
  Component,
  signal,
  Signal,
} from '@angular/core';

import { Guid } from '@web/utils';
import { ExternalLinkComponent, SvgIcon } from '@web/shared/ui';
import { FooterIconComponent } from '../footer-icon/footer-icon.component';

type SocialMedia = { id: Guid; link: string; icon: SvgIcon };

@Component({
  selector: 'app-footer-social-links',
  imports: [ExternalLinkComponent, FooterIconComponent],
  templateUrl: './footer-social-links.component.html',
  styleUrl: './footer-social-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterSocialLinksComponent {
  protected readonly socialMediaLinks = this.socialMediaLinksSignal();

  private socialMediaLinksSignal(): Signal<Array<SocialMedia>> {
    return signal([
      {
        id: '3fcdd7ac-318d-4c02-8bd3-099a6b3b57fb',
        link: 'https://www.facebook.com/PUREbeautypl',
        icon: SvgIcon.Facebook,
      },
      {
        id: '37461519-0d5a-4c43-b1d7-8bc8afaf6cc0',
        link: 'https://www.instagram.com/purebeauty_pl/',
        icon: SvgIcon.Instagram,
      },
      {
        id: '07887a5a-a369-471a-9b3d-5eb29674cec5',
        link: 'https://www.youtube.com/channel/UCm2pSx1vmn6xnZyxFH_GnoA/featured',
        icon: SvgIcon.Youtube,
      },
      {
        id: '9fcc0609-dcab-4d3b-b020-19e0577fd116',
        link: 'https://www.tiktok.com/@purebeauty.pl',
        icon: SvgIcon.TikTok,
      },
    ]);
  }
}
